export const ACCESS_CODES_TABLE_SORT_ENABLED = 'ACCESS_CODES_TABLE_SORT_ENABLED'
export const ACCESS_CODES_TABLE_SORT_DISABLED = 'ACCESS_CODES_TABLE_SORT_DISABLED'
export const ACCESS_CODES_TABLE_SORT_UPDATED = 'updated'

const enable = (sortField, order) => ({
  type: ACCESS_CODES_TABLE_SORT_ENABLED,
  sortField,
  order,
})

const disable = () => ({
  type: ACCESS_CODES_TABLE_SORT_DISABLED,
})

export const enableAccessCodesSort = (sortField, order) => (dispatch) => dispatch(enable(sortField, order))

export const disableAccessCodesSort = () => (dispatch) => dispatch(disable())
